import { Link } from 'react-router-dom';
import { LogisticsStatusBadge, LogisticsTypeBadge } from '@/modules/logistics/components';
import { ReservationStatusBadge } from '@/modules/reservations/components';
import type { CalendarEvent } from '@/modules/calendar/types';
import { formatIsoDate } from '@/modules/calendar/utils';
import { modulePaths } from '@/routes/paths';

type CalendarDayViewProps = {
  anchorDate: string;
  events: CalendarEvent[];
};

function eventDetailLink(event: CalendarEvent): string {
  if (event.source === 'logistics' && event.logisticsOrderId) {
    return `${modulePaths.logistics}/${event.logisticsOrderId}`;
  }
  if (event.reservationId) {
    return `${modulePaths.reservations}/${event.reservationId}`;
  }
  return modulePaths.calendar;
}

export function CalendarDayView({ anchorDate, events }: CalendarDayViewProps) {
  if (events.length === 0) {
    return (
      <p className="auth-muted">
        No hay actividades para el {formatIsoDate(anchorDate)}.
      </p>
    );
  }

  return (
    <ul className="calendar-day-list">
      {events.map((ev) => (
        <li key={ev.id} className="calendar-day-list__item">
          <div className="calendar-day-list__header">
            <Link to={eventDetailLink(ev)}>
              <strong>{ev.title}</strong>
            </Link>
            {ev.source === 'logistics' && ev.logisticsType && ev.logisticsStatus ? (
              <>
                <LogisticsTypeBadge type={ev.logisticsType} />
                <LogisticsStatusBadge status={ev.logisticsStatus} />
              </>
            ) : null}
            {ev.source === 'reservation' && ev.reservationStatus ? (
              <ReservationStatusBadge status={ev.reservationStatus} />
            ) : null}
          </div>
          <p className="auth-muted">
            {ev.start}
            {ev.end !== ev.start ? ` → ${ev.end}` : ''}
            {ev.clientName ? ` · ${ev.clientName}` : ''}
          </p>
          {ev.relatedInventoryItems.length > 0 ? (
            <p className="auth-muted">
              {ev.relatedInventoryItems.length} artículo(s) asociado(s)
            </p>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
